import { AxiosError } from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../../../../components/Modal';
import {
  backendErrorNotification,
  frontendNotification,
} from '../../../../../../../components/Notification';
import HttpStatus from '../../../../../../../enums/httpStatus';
import { motivesByActionsDeleteReq } from '../../../../../../../services/requests';
import * as TP from '../../../../../../../types/apiResponseTypes';
import * as s from '../styles';

type Props = {
  closeModal: () => void;
  reqGetAllMotiveByActions: () => void;
  itemSelected: TP.MotiveByAction;
};

const DeleteMotiveByAction = ({
  closeModal,
  reqGetAllMotiveByActions,
  itemSelected,
}: Props) => {
  const { t } = useTranslation();
  const [waitingDelete, setWaitingDelete] = useState(false);

  const reqDelete = async () => {
    setWaitingDelete(true);

    try {
      const res = await motivesByActionsDeleteReq.store({
        action_id: itemSelected.actionId,
      });

      if (res.status === HttpStatus.OK) {
        frontendNotification({
          message: t('successfullyDeleted'),
          type: 'success',
        });
        closeModal();
        reqGetAllMotiveByActions();
      } else {
        throw res;
      }
    } catch (err) {
      if (!motivesByActionsDeleteReq.axios.isCancel(err)) {
        backendErrorNotification(err as AxiosError<any, any>);
      }
    } finally {
      setWaitingDelete(false);
    }
  };

  return (
    <Modal
      title={`${t('delete')} ${t('motivesByActions')}`}
      showModal
      closeModal={closeModal}
      action={() => reqDelete()}
      actionNameBtn={t('delete')}
      isLoading={waitingDelete}
      cancelButton={closeModal}
    >
      <s.ModalContent>
        <p>
          {`${t('deleteSure')}?`}
          <br />
          <br />
          <b>{t('action')}:</b> {itemSelected.actionLabel}
          <br />
          <br />
          <b>{t('motives')}:</b> {itemSelected.motives.map((motive) => motive.description).join(', ')}
        </p>
      </s.ModalContent>
    </Modal>
  );
};

export default DeleteMotiveByAction;
